import { jsPDF } from "jspdf";
import banner1 from "../../../Assets/ptags/banner.jpg";
import { Url, generateBarcodeBase64, getAdjustedPrice } from "../../../Services/Api";

import "../../../Assets/ptags/fonts/Montserrat-Bold";
import "../../../Assets/ptags/fonts/Montserrat-ExtraBold";
import "../../../Assets/ptags/fonts/Montserrat-Black";
import "../../../Assets/ptags/fonts/Montserrat-ExtraBoldItalic";
import "../../../Assets/ptags/fonts/Montserrat-BoldItalic";
import "../../../Assets/ptags/fonts/anton";


const now = new Date();
const timestamp = now
    .toISOString()           // e.g., "2025-08-15T21:45:30.123Z"
    .replace(/[:.]/g, '-')   // Replace colon and dot with dash
    .replace('T', '_')       // Replace 'T' with underscore
    .split('Z')[0];          // Remove trailing 'Z'



export const generatePDFBarCode = (sectionsCount, bannerImg) => {


    const width = 1632;
    const height = 1056;
    const doc = new jsPDF({
        orientation: "landscape",
        unit: "pt",
        format: [width, height],
    });

    const sectionWidth = width / 2;  // 1632 / 2 = 816 pt
    const sectionHeight = height / 2; // 1056 / 2 = 528 pt


    const bannerImgWidth = (width / 2) - 5;
    const bannerImgHeight = 94;

    const maxSectionsPerPage = 4; // 4 sections per page (2x2 grid per page)
    let currentSection = 0;

    // Loop through the sections and handle pages
    while (currentSection < sectionsCount.length) {
        // Add a new page if this isn't the first page
        if (currentSection > 0) {
            doc.addPage();
        }

        // Calculate number of sections on the current page
        const sectionsOnThisPage = Math.min(maxSectionsPerPage, sectionsCount.length - currentSection);

        for (let i = 0; i < sectionsOnThisPage; i++) {
            const sectionIndex = currentSection + i;
            const xPos = (i % 2) * (width / 2) + 2.5;
            const yPos = Math.floor(i / 2) * (height / 2) + 2.5;
            const yPosBtm = Math.floor(i / 2) * (height / 2) + 2.5;

            if (sectionIndex < sectionsCount.length) {
                // Banner Image
                doc.addImage(bannerImg, "JPEG", xPos, yPos, bannerImgWidth, bannerImgHeight);

                // Main Rectangle
                const sectionRectX = xPos + 2.5;
                const sectionRectY = yPos + bannerImgHeight + 4.8;
                const sectionRectWidth = sectionWidth / 2.9;
                const sectionRectHeight = sectionHeight - (bannerImgHeight + 12);





                doc.setLineWidth(2);
                doc.setDrawColor(71, 74, 119);



                const sectionMainImageX = xPos + ((sectionWidth / 3) * 2);
                const sectionMainImageWidth = sectionWidth / 3;
                const sectionMainImageHeight = 165;



                // // main product image
                // doc.addImage("https://fdapi.thefurnituredepots.com/uploads/media/Products/1772083464215_428_temp_Lavinton-Bedroom-Set-.jpg", "JPEG", sectionMainImageX, sectionRectY, sectionMainImageWidth, sectionMainImageHeight);

                const productImageUrl = sectionsCount[sectionIndex]?.image;
                const name = sectionsCount[sectionIndex]?.name;
                const sku = "Model#" + sectionsCount[sectionIndex]?.sku;
                const sale_price = sectionsCount[sectionIndex]?.variations[0].sale_price;
                const regular_price = sectionsCount[sectionIndex]?.variations[0].regular_price;

                if (productImageUrl) {
                    doc.addImage(productImageUrl, "JPEG", sectionMainImageX, sectionRectY, sectionMainImageWidth, sectionMainImageHeight);
                }

                // doc.addFont("Montserrat-ExtraBoldItalic-bolditalic.ttf", "Montserrat-ExtraBoldItalic-bolditalic", "bold");
                doc.setFont("Montserrat-Bold", "bold");
                doc.setTextColor(0, 0, 0); // white text
                doc.setFontSize(10);
                // doc.setFont("helvetica", "bold");

                // Text position (adjust as needed)
                const textX = sectionMainImageX + (sectionMainImageWidth - 15);
                const textY = sectionRectY + 15;

                // Example text
                doc.text(name, textX, textY, { align: 'right' });
                doc.setTextColor(0, 0, 0); // white text
                doc.setFontSize(12);
                doc.setFont("helvetica", "normal");
                doc.text(sku, textX, textY + 12, { align: 'right' });





                doc.rect(sectionRectX, sectionRectY, sectionRectWidth, sectionRectHeight, 'S');

                const rectXM = xPos + sectionRectWidth + 7;
                const rectYM = sectionRectY;
                const rectWM = ((width / 2) - sectionRectWidth) - 15;
                const rectHM = 277;

                doc.rect(rectXM, rectYM, rectWM, rectHM, 'S');

                doc.setLineWidth(2);
                doc.setDrawColor(71, 74, 119);
                // Vertical line (inside section)
                const verticalX = xPos + (sectionWidth / 1.5) + 4.5; // add xPos for column
                doc.line(verticalX, sectionRectY, verticalX, sectionRectY + sectionRectHeight - 146.5);

                // Horizontal line (inside section)
                const horizontalStartX = xPos + (sectionWidth / 3) + 17;
                const horizontalEndX = xPos + ((sectionWidth / 3) * 2) + 5;
                const horizontalY = sectionRectY + 140; // relative to this section
                doc.line(horizontalStartX, horizontalY, horizontalEndX, horizontalY);

                // Horizontal divider inside main rectangle
                const lineY = sectionRectY;
                // doc.setLineWidth(2);
                // doc.line(
                //     sectionRectX,
                //     yPosBtm + 415,
                //     sectionRectX + sectionRectWidth,
                //     yPosBtm + 415
                // );


                const subSection1Width = sectionWidth / 2.9; // Assuming this is your sub-section width

                const wasPriceStartY = yPos;

                // Main barcode SKU (above price section)
                const mainbarcodeSKU = sectionsCount[sectionIndex]?.sku;
                if (mainbarcodeSKU) {
                    const barcodeImg = generateBarcodeBase64(mainbarcodeSKU);

                    const barcodeWidth = subSection1Width - 40; // width inside the sub-section
                    const barcodeHeight = 35; // adjust height as needed

                    // X position: center within sub-section
                    const barcodeX = xPos + 275 + (subSection1Width - barcodeWidth) / 2;

                    // Y position: above the "Was $" text
                    const barcodeY = wasPriceStartY + 105; // adjust 90 to place it nicely above text1

                    doc.addImage(barcodeImg, "PNG", barcodeX, barcodeY, barcodeWidth, barcodeHeight);
                }




                // Text for first line
                const text1 = sectionsCount[sectionIndex]?.variations[0].value;
                doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
                doc.setTextColor(40, 142, 169); // black text
                doc.setFontSize(11);
                const text1Width = doc.getTextWidth(text1);

                // Calculate the starting x position to center the text within the sub-section
                const wasPriceStartX1 = xPos + 275 + (subSection1Width - text1Width) / 2;
                doc.text(text1, wasPriceStartX1, wasPriceStartY + 150);

                // Text for second line
                const text2 = "was $" + regular_price;
                doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
                doc.setTextColor(0, 0, 0); // black text
                doc.setFontSize(16);
                const text2Width = doc.getTextWidth(text2);

                // Calculate the starting x position to center the second text
                const wasPriceStartX2 = xPos + 275 + (subSection1Width - text2Width) / 2;
                doc.text(text2, wasPriceStartX2, wasPriceStartY + 170);

                // Text for third line
                const text3 = "$" + sale_price;
                doc.setFont("Montserrat-Black", "normal");
                doc.setTextColor(253, 0, 0); // black text
                doc.setFontSize(50);
                const text3Width = doc.getTextWidth(text3);

                // Calculate the starting x position to center the third text
                const wasPriceStartX3 = xPos + 275 + (subSection1Width - text3Width) / 2;
                doc.text(text3, wasPriceStartX3, wasPriceStartY + 220);

                if (sectionsCount[sectionIndex]?.variations.length > 1) {
                    // Print heading
                    doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
                    doc.setTextColor(0, 0, 0);
                    doc.setFontSize(11);
                    doc.text("Group Pricing", xPos + 10, lineY + 20);

                    const sectionWidth = width / 3; // total width for group pricing section
                    const columnGap = 20; // space between columns
                    const maxItemsPerColumn = 9; // max items in a single column
                    const colWidth = (sectionWidth - columnGap) / 2; // width per column

                    const variationSpacing = 10; // space between text and barcode
                    const barcodeHeight = 20; // height of barcode
                    const rowHeight = 8 + variationSpacing + barcodeHeight + 5; // height for each variation row
                    const startY = lineY + 30; // start below heading

                    // const variations = sectionsCount[sectionIndex].variations;

                    // for (let i = 1; i < variations.length; i++) {
                    //     const variation = variations[i];

                    //     // Determine column: first 9 items in first column, next 9 in second, etc.
                    //     const col = Math.floor((i - 1) / maxItemsPerColumn);

                    //     // Row within that column
                    //     const rowInCol = (i - 1) % maxItemsPerColumn;

                    //     // Conditional Y offset: if second column (col = 1), start lower
                    //     const yOffset = startY + rowInCol * rowHeight + (col === 1 ? 130 : 0);
                    //     const xOffset = xPos + 10 + col * (colWidth + columnGap);

                    //     // Print value
                    //     doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
                    //     doc.setTextColor(0, 0, 0);
                    //     doc.setFontSize(8);
                    //     doc.text(variation?.value || "N/A", xOffset, yOffset);

                    //     // Print price below value
                    //     const valueWidth = doc.getTextWidth(variation?.value || "N/A");
                    //     doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
                    //     doc.setTextColor(253, 0, 0);
                    //     doc.setFontSize(9);
                    //     doc.text(`$${variation?.sale_price || "0.00"}`,xOffset, yOffset+9.5);

                    //     // Add barcode under price
                    //     const barcodeSKU = variation?.sku || sectionsCount[sectionIndex]?.sku;
                    //     if (barcodeSKU) {
                    //         const barcodeImg = generateBarcodeBase64(barcodeSKU);
                    //         const barcodeX = xOffset;
                    //         const barcodeY = yOffset + 10; // gap between price and barcode
                    //         const barcodeWidth = colWidth - 10; // fit within column
                    //         doc.addImage(barcodeImg, "PNG", barcodeX, barcodeY, barcodeWidth, barcodeHeight);
                    //     }
                    // }

                    const variations = sectionsCount[sectionIndex].variations;

                    // 🔴 Limit total items: 9 (col1) + 3 (col2) = 12
                    const maxTotalItems = 12;

                    for (let i = 1; i < variations.length && i <= maxTotalItems; i++) {
                        const variation = variations[i];

                        let col, rowInCol;

                        if (i <= 9) {
                            // ✅ First column (max 9)
                            col = 0;
                            rowInCol = i - 1;
                        } else {
                            // ✅ Second column (max 3)
                            col = 1;
                            rowInCol = i - 10; // starts from 0
                        }

                        const xOffset = xPos + 10 + col * (colWidth + columnGap);
                        // const yOffset = startY + rowInCol * rowHeight;
                        const yOffset = startY + rowInCol * rowHeight + (col === 1 ? 130 : 0);

                        // Print value
                        doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
                        doc.setTextColor(0, 0, 0);
                        doc.setFontSize(8);
                        doc.text(variation?.value || "N/A", xOffset, yOffset);

                        // Price
                        doc.setFontSize(9);
                        doc.setTextColor(253, 0, 0);
                        doc.text(`$${variation?.sale_price || "0.00"}`, xOffset, yOffset + 9.5);

                        // Barcode
                        const barcodeSKU = variation?.sku || sectionsCount[sectionIndex]?.sku;
                        if (barcodeSKU) {
                            const barcodeImg = generateBarcodeBase64(barcodeSKU);
                            const barcodeWidth = colWidth - 10;
                            const barcodeY = yOffset + 10;

                            doc.addImage(barcodeImg, "PNG", xOffset, barcodeY, barcodeWidth, barcodeHeight);
                        }
                    }
                }




                // Optional: another right rectangle (if still needed)
                const rightRectX = xPos + (sectionWidth / 2.83);
                const rightRectY = yPos + sectionHeight / 1.39 + 0.5;
                const rightRectW = sectionWidth / 1.57;
                const rightRectH = sectionHeight / 3.75;

                doc.setLineWidth(2);
                doc.rect(rightRectX, rightRectY, rightRectW, rightRectH, 'S');



                // Custom column widths (6 columns now)
                const col1 = rightRectW * 0.15; // left label
                const col2 = rightRectW * 0.10; // left price
                const col3 = rightRectW * 0.25; // left barcode (wider)

                const col4 = rightRectW * 0.15; // right label
                const col5 = rightRectW * 0.10; // right price
                const col6 = rightRectW * 0.25; // right barcode (wider)

                // Row height
                const rowHeight = rightRectH / 4;

                doc.setLineWidth(2);
                doc.setDrawColor(71, 74, 119);

                // Horizontal lines
                for (let r = 1; r < 5; r++) {
                    const y = rightRectY + r * rowHeight;
                    doc.line(rightRectX, y, rightRectX + rightRectW, y);
                }

                // Vertical lines (NOW 5 lines)
                const colX1 = rightRectX + col1;
                const colX2 = colX1 + col2;
                const colX3 = colX2 + col3;
                const colX4 = colX3 + col4;
                const colX5 = colX4 + col5;

                doc.line(colX1, rightRectY, colX1, rightRectY + rightRectH);
                doc.line(colX2, rightRectY, colX2, rightRectY + rightRectH);
                doc.line(colX3, rightRectY, colX3, rightRectY + rightRectH);
                doc.line(colX4, rightRectY, colX4, rightRectY + rightRectH);
                doc.line(colX5, rightRectY, colX5, rightRectY + rightRectH);

                // Data
                const values = sectionsCount[sectionIndex]?.individuals || [];
                const itemsPerRow = 2;
                const totalRows = Math.ceil(values.length / itemsPerRow);

                // Draw rows
                for (let r = 0; r < totalRows; r++) {
                    const y = rightRectY + (r + 1) * rowHeight;

                    const leftIndex = r * itemsPerRow;
                    const rightIndex = leftIndex + 1;

                    const textY = y - rowHeight / 2 + 4;

                    // ================= LEFT ITEM =================
                    if (values[leftIndex]) {
                        const left = values[leftIndex];
                        const leftLabel = left.inputValue || "";
                        const leftPrice = left.p_price ? "$" + left.p_price : "";

                        const leftLabelX = rightRectX + 5;
                        const leftPriceX = rightRectX + col1 + 5;
                        const leftBarcodeX = rightRectX + col1 + col2 + 2;

                        doc.setFont("Montserrat-BoldItalic", "bolditalic");
                        doc.setFontSize(12);

                        // Label
                        doc.setTextColor(0, 0, 0);
                        doc.text(leftLabel, leftLabelX, textY);

                        // Price
                        doc.setTextColor(252, 0, 0);
                        doc.text(leftPrice, leftPriceX, textY);

                        // Barcode
                        if (left?.sku) {
                            const barcodeImg = generateBarcodeBase64(left.sku);

                            const barcodeY = textY - 15;
                            const barcodeWidth = col3 - 10;
                            const barcodeHeight = 22;

                            doc.addImage(barcodeImg, "PNG", leftBarcodeX, barcodeY, barcodeWidth, barcodeHeight);
                        }
                    }

                    // ================= RIGHT ITEM =================
                    if (values[rightIndex]) {
                        const right = values[rightIndex];
                        const rightLabel = right.inputValue || "";
                        const rightPrice = right.p_price ? "$" + right.p_price : "";

                        const rightStartX = rightRectX + col1 + col2 + col3;

                        const rightLabelX = rightStartX + 5;
                        const rightPriceX = rightStartX + col4 + 5;
                        const rightBarcodeX = rightStartX + col4 + col5 + 5;

                        doc.setFont("Montserrat-BoldItalic", "bolditalic");
                        doc.setFontSize(12);

                        // Label
                        doc.setTextColor(0, 0, 0);
                        doc.text(rightLabel, rightLabelX, textY);

                        // Price
                        doc.setTextColor(252, 0, 0);
                        doc.text(rightPrice, rightPriceX, textY);

                        // Barcode
                        if (right?.sku) {
                            const barcodeImg = generateBarcodeBase64(right.sku);

                            const barcodeY = textY - 15;
                            const barcodeWidth = col6 - 10;
                            const barcodeHeight = 22;

                            doc.addImage(barcodeImg, "PNG", rightBarcodeX, barcodeY, barcodeWidth, barcodeHeight);
                        }
                    }
                }


            }
        }


        // Draw horizontal dashed line (same for every page)
        doc.setLineDashPattern([10, 5], 0);
        doc.setDrawColor(0); // black
        doc.setLineWidth(1);
        doc.line(0, height / 2, width, height / 2); // Horizontal line at half height

        // Draw vertical dashed line (same for every page)
        doc.line(width / 2, 0, width / 2, height); // Vertical line at half width

        // Increment currentSection for the next page
        currentSection += sectionsOnThisPage;
    }

    // Save the PDF
    doc.save(`price-tags_${timestamp}.pdf`);
};
